.ux-toggle-button {
  color: $color-black;
  cursor: pointer;
  display: inline-block;
  padding: 0 5px;
  user-select: none;

  &--on {
    color: $color-green;

    .ux-toggle-button__label--on {
      display: inline;
    }

    .ux-toggle-button__label--off {
      display: none;
    }
  }

  &--off {
    .ux-toggle-button__label--on {
      display: none;
    }

    .ux-toggle-button__label--off {
      display: inline;
    }
  }

  &--has-error {
    color: $color-red;
  }

  &__label {
    margin-right: 10px;
  }

  .ux-icon {
    fill: currentcolor;
  }
}
